import { makeStyles } from "@material-ui/core";
import styled from "styled-components";

import { theme } from "../../themes/themes";
export const CardSpeaker = styled.div`
  /* background: linear-gradient(to bottom, ${({ theme }) => theme.neutral.white} 50%, #273238 50%); */
  background-color: ${({ theme }) => theme.primaryBackgroundLight};
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin: 1em;
  border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  border-radius: 10px;
  padding: 10px;
`;

export const SpeakerName = styled.div`
  color: ${({ theme }) => theme.primary.purple};
  font-weight: 600;
  text-transform: capitalize;
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  font-size: 17px;
`;

export const JobPositionSpeaker = styled.div`
  color: ${({ theme }) => theme.primary.purple};
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  overflow-wrap: anywhere;
`;

export const CompanyNameSpeaker = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  :hover {
    color: blue;
    text-decoration: underline;
  }
`;

export const WebSiteSpeaker = styled.div`
  color: ${({ theme }) => theme.primary.purple};
`;

export const ButtonSpeaker = styled.button`
  border: 1px solid ${({ theme }) => theme.primary.purple};
  background-color: transparent;
  font-weight: 600;
  padding: 0.5em 1em;
  margin-top: 1em;
  text-transform: uppercase;
  width: 130px;
  color: ${({ theme }) => theme.button.primary};
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  :hover {
    opacity: 0.8;
  }
`;

export const useStyles = makeStyles(() => ({
  imgSpeaker: {
    width: "9em",
    height: "9em",
    margin: "1em 0",
    borderRadius: "99px",
    maxWidth: "126px",
    maxHeight: "126px",
  },
}));
